import React from 'react';
import { Container } from 'themes/MoGrid';
//import CMSContext from 'context/CMSContext';
import { CMSContext, ConfigContext } from "../../../context/AppContext";
import helper from 'components/utils/helper';

const NoRoute = () => {
  const cms = React.useContext(CMSContext);
  const [error, setError] = React.useState();
  const [showMessage, setShowMessage] = React.useState(false);
  let path = window.location.pathname;
  let message = `404: Page not found: ${path}`;
  const urlLocale = helper.getUrlLocale();
  const currentLocaleLanguage = urlLocale.language;
  const currentUrlCountry = urlLocale.country;
  const regex = new RegExp(`(/${currentLocaleLanguage}/story/|/story/)`, "g");
  const isStoryPage = path.match(regex);
  const [isLocaleLanguage, setIsLocaleLanguage] = React.useState(false);
  
  React.useEffect(() => {


    if(isStoryPage){
    let url = helper.getLegacyAssetUrl('json', `resources/json/global`, currentUrlCountry);
      if (path.includes(`/${currentLocaleLanguage}/`)) {
        path = path.replace(`/${currentLocaleLanguage}`, '');
        setIsLocaleLanguage(true);
      }

      if (!url.includes(path)) {
        // Update the url with the correct path
        url = `${url}${path}`;
      }
      
      // Get the global story
      fetch(url)
        .then((res) => res.json())
        .then(
          result => {
            if(result) {
              // if the language is present we need to add it back in 
              if (isLocaleLanguage) {
                result['preRenderUrl'][0] = `/${currentLocaleLanguage}${result['preRenderUrl'][0]}`;
                result['pages']['stories']['components'][0]['url'] = `/${currentLocaleLanguage}${result['pages']['stories']['components'][0]['url']}`;
              }
              addNewStoryToCms(result);
            }
          },
          error => {
            setShowMessage(true);
            console.error(error.toString());
            setError('There was an error with the page');
          }
        );
    } else {
      setShowMessage(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [isLocaleLanguage]);


  // Check if a story page

  function addNewStoryToCms(story){
    let newCms = {...cms}; // Must be new object otherwise MoRouter won't re-render
    // Set global story to current cms sitemap
    if(story.preRenderUrl && story.pages && story.components){
      newCms.preRenderUrl.push(story.preRenderUrl[0]);
      newCms.pages.stories.components.push(story.pages.stories.components[0]);
      newCms.components[story.pages.stories.components[0].id] = story.components[story.pages.stories.components[0].id];
      // Dispatch change cms event
      window.dispatchEvent(new CustomEvent('changeCms', { detail: {cms: newCms} }));
    }
  }

  return (
    <Container>
    {showMessage && <div>{message}</div>}
    {error && <div>{error}</div>}
    </Container>
  );
}

export default NoRoute;
